import { Component } from '@angular/core';

@Component({
  selector: 'app-graph-navigator',
  templateUrl: './department-productivity.component.html',
  styleUrls: ['./department-productivity.component.scss'],
})
export class DepartmentProductivityComponent {}
